import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  quote: 'Вони не просто зробили ідеальну подію, вони перевершили всі наші очікування. Рівень сервісу, який важко знайти навіть у Європі.',
  author: 'Олена В.',
  role: 'CEO, Tech Innovators'
}, {
  quote: 'Кожна деталь нашого весілля була бездоганною. Це була справжня магія, створена командою професіоналів.',
  author: 'Максим та Анна',
  role: 'Приватні клієнти'
}];
export function Testimonials() {
  return <section id="testimonials" className="py-32 bg-background relative overflow-hidden" data-id="element-168">
      {/* Decorative background element */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] border border-white/5 rounded-full pointer-events-none" data-id="element-169"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] border border-white/5 rounded-full pointer-events-none" data-id="element-170"></div>

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-171">
        <div className="text-center mb-20" data-id="element-172">
          <h2 className="text-gold uppercase tracking-[0.2em] text-sm font-sans mb-4" data-id="element-173">
            Відгуки
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-24 max-w-5xl mx-auto" data-id="element-174">
          {testimonials.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: index * 0.2
        }} className="flex flex-col" data-id="element-175">
              <span className="text-gold text-6xl font-serif leading-none mb-6" data-id="element-176">
                "
              </span>
              <p className="text-2xl md:text-3xl font-serif text-ivory/90 leading-relaxed mb-8 flex-grow" data-id="element-177">
                {item.quote}
              </p>
              <div data-id="element-178">
                <p className="font-sans text-ivory uppercase tracking-widest text-sm mb-1" data-id="element-179">
                  {item.author}
                </p>
                <p className="font-sans text-gold/70 text-sm" data-id="element-180">{item.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}